import MemoComment from './MemoComment';

class Memo {
  id: number;

  groupId: number;

  memberId: number;

  memo: string = '';

  tags: string[];

  reporters: number[] = [];

  performers: number[] = [];

  watchers: number[] = [];

  comments: MemoComment[] = [];

  reportStatus: number;

  finalReporter: number;

  deadline: number;

  completed: boolean;

  created: number;

  updated: number;
}

export default Memo;



// WEBPACK FOOTER //
// ./src/entities/Memo.ts